// PHASE 1 LOCKED · symbol registry — do not add/remove/replace symbols.
// LUCKY DUCKY — symbol registry.
// SOURCE OF TRUTH: LD-02 through LD-11 (10 approved reel symbols) + LD-01 mascot + LD-16 logo.
// No other symbols are permitted. If a new symbol is ever needed, STOP and ask the product owner.
export const SYMBOLS = {
  BONUS:    { id: 'BONUS',    label: 'Bonus Duck',  asset: '/games/lucky-ducky/LD-02-bonus-duck.png',  isBonus: true },
  WILD:     { id: 'WILD',     label: 'Double Wild', asset: '/games/lucky-ducky/LD-03-double-wild.png', isWild: true, wildMultiplier: 2 },
  RED_7:    { id: 'RED_7',    label: 'Red 7',       asset: '/games/lucky-ducky/LD-04-red-7.png' },
  // BELL/BAR family — the three BAR tiers now render as their own
  // standalone plaque art (single / double / triple).  The premium bell
  // is kept as a SEPARATE asset (ART.bell) — not composited onto the bars.
  B3R:      { id: 'B3R',      label: 'Triple BAR', asset: '/games/lucky-ducky/LD-bar-triple.png' },
  B2R:      { id: 'B2R',      label: 'Double BAR', asset: '/games/lucky-ducky/LD-bar-double.png' },
  B1R:      { id: 'B1R',      label: 'Single BAR', asset: '/games/lucky-ducky/LD-bar-single.png' },
  PLUM:     { id: 'PLUM',     label: 'Plum',        asset: '/games/lucky-ducky/LD-08-plum.png' },
  BELL:     { id: 'BELL',     label: 'Bell',        asset: '/games/lucky-ducky/LD-bell-premium.png' },
  WATERMEL: { id: 'WATERMEL', label: 'Watermelon',  asset: '/games/lucky-ducky/LD-09-watermelon.png' },
  ORANGE:   { id: 'ORANGE',   label: 'Orange',      asset: '/games/lucky-ducky/LD-10-orange.png' },
  CHERRY:   { id: 'CHERRY',   label: 'Cherries',    asset: '/games/lucky-ducky/LD-11-cherries.png' },
};

// Ordered ID list — the ONLY symbols allowed on the reels.
export const SYMBOL_IDS = ['BONUS', 'WILD', 'RED_7', 'B3R', 'B2R', 'B1R', 'BELL', 'PLUM', 'WATERMEL', 'ORANGE', 'CHERRY'];

// Non-reel art references.
export const ART = {
  logo:        '/games/lucky-ducky/LD-16-logo.png',
  mascot:      '/games/lucky-ducky/LD-01-mascot.png',
  environment: '/games/lucky-ducky/LD-12-environment.png',
  reelBoard:   '/games/lucky-ducky/LD-13-reel-board.png',
  betoRespins: '/games/lucky-ducky/LD-14-beto-respins.png',
  uiHud:       '/games/lucky-ducky/LD-15-ui-hud.png',
  bell:        '/games/lucky-ducky/LD-bell-premium.png',
};
